import { render, staticRenderFns } from "./GroupRegisterForm.vue?vue&type=template&id=5289e395&"
import script from "./GroupRegisterForm.vue?vue&type=script&lang=js&"
export * from "./GroupRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports